module.exports = __webpack_public_path__ + "static/media/holiday-games-logo.22bfb70c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/scene--intro/holiday-games-logo.png
 ** module id = 465
 ** module chunks = 0
 **/